
import axios from "axios";

async function sendOTPMessage(body) {
    const response = await axios.post(process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE+'message/sendOTPMessage', body)
    return response;
}
async function sendOTPMessageMail(body) {
    const response = await axios.post(process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE+'message/sendOTPMessageToMail', body)
    return response;
}


async function sendMailTo(body) {
    const response = await axios.post(process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE+'mail/sendMailTo', body)
    return response;
}

async function readReraPdfFile(url){
    const response = await axios.post(process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE+'pdfToJson/convert', {pdf:url})
    return response;
}
async function restartServer(){
    const response = await axios.get(process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE+'payments', {})
    return response;   
}
async function sendMessage(body){
    const response = await axios.post(process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE+'message/sendMessage', body)
    return response;
}



// parseCertificateText.js
export const parseCertificateText = (text) => {
  const toTs = (d) => {
    const [dd, mm, yyyy] = d.split("/");
    return new Date(`${yyyy}-${mm}-${dd}`).getTime();
  };

  const dateMatch = text.match(
    /commencing from\s+(\d{2}\/\d{2}\/\d{4})\s+and ending with\s+(\d{2}\/\d{2}\/\d{4})/i
  );
  const startDate = dateMatch ? toTs(dateMatch[1]) : null;
  const endDate = dateMatch ? toTs(dateMatch[2]) : null;

  const typeMatch = text.match(/type of agent\s*[:\-]?\s*([A-Za-z ]+)/i);
  const typeOfAgent = typeMatch ? typeMatch[1].trim() : "";

  let cpType = "";
  if (typeOfAgent) {
    cpType = /individual/i.test(typeOfAgent) ? "Individual" : "Entity";
  }
  if (!cpType || !["Individual", "Entity"].includes(cpType)) {
    cpType = "Individual"; // ✅ fallback
  }

  const certMatch = text.match(
    /registration\s*(?:no\.?|number)\s*[:\-]?\s*([A-Za-z0-9\/\-]+)/i
  );
  const certificateNo = certMatch ? certMatch[1].trim() : "";

  const nameMatch =
    text.match(
      /Mr\.?\s*\/\s*Ms\.?\s+([A-Za-z][A-Za-z.\s]*?)\s+son\s*\/\s*daughter\s+of/i
    ) ||
    text.match(
      /name\s*of\s*agent\s*[:\-]?\s*([A-Za-z0-9&.,\-() ]{3,})/i
    );
  const agentName = nameMatch ? nameMatch[1].trim() : "";

  return { startDate, endDate, typeOfAgent, cpType, certificateNo, agentName };
};

export {  sendOTPMessage,sendMailTo,readReraPdfFile,restartServer,sendMessage,sendOTPMessageMail,}